<template>
	<div class="wrap wrap--products">
        <!-- 헤더 -->
		<main-header :header-type="'shop'"></main-header>

		<!-- 메인 -->
		<main class="main" role="main">
			<div class="center-title">
				<h2>새집처럼 <b>기획전</b></h2>
			</div>
			<!-- 리스트 섹션 -->
			<section class="list-section">
				<div class="inner">
					<!-- 기획전 리스트 -->
					<div class="exhibition-list-container">
						<div v-for="list in 10" class="exhibition-list">
							<exhibition-list
							:index = "index"
							:list-style = "'page'"
							>
							</exhibition-list>
						</div>
					</div>
				</div>
			</section>
		</main>

		<!-- 푸터 -->
		<main-footer></main-footer>
	</div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import ExhibitionList from "@/components/client/exhibition/list.vue";

export default{
	components: {
		MainHeader,
		MainFooter,
		ExhibitionList
	},
	data: () => {
		return{
			index: 0,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>
